import { creatorbase } from '@round/api';
import { SVGProps } from 'react';
import { assets } from '@round/whitelabel-ui';

const {
    TiktokSolid: TiktokSolidIcon,
    TiktokColor: TiktokColoredIcon,
    InstagramSolid: InstagramSolidIcon,
    InstagramColor: InstagramColoredIcon,
    YoutubeSolid: YoutubeSolidIcon,
    YoutubeColor: YoutubeColoredIcon,
} = assets;

type Props = {
    platform: creatorbase.Platform;
    colored?: boolean;
} & SVGProps<SVGSVGElement>;

type IconsMap = { [key in creatorbase.Platform]?: typeof TiktokSolidIcon };

const solidIcons: IconsMap = {
    tiktok: TiktokSolidIcon,
    instagram: InstagramSolidIcon,
    youtube: YoutubeSolidIcon,
};

const coloredIcons: IconsMap = {
    tiktok: TiktokColoredIcon,
    instagram: InstagramColoredIcon,
    youtube: YoutubeColoredIcon,
};

const PlatformIcon = ({ platform, colored, ...props }: Props) => {
    const Icon = colored ? coloredIcons[platform] : solidIcons[platform];
    if (!Icon) {
        return null;
    }

    return <Icon {...props} />;
};

export default PlatformIcon;
